var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransporteParadaBusMarquesina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "iguawavapa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.431372 0 0 0 0 0.384314 0 0 0 0 0.349020 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    filter: "url(#iguawavapa)",
    transform: "translate(-21.000000, -316.000000) translate(21.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.563 14.441L4.563 15.708 5.785 15.708 5.785 17.979 7.073 17.979 7.073 15.708 14.037 15.708 14.037 17.979 15.325 17.979 15.325 15.708 16.547 15.708 16.547 14.441z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.713 16.734L19.713 4.522 18.425 4.522 18.425 9.339 13.269 9.339 13.269 7.414 7.731 7.414 7.731 9.339 2.685 9.339 2.685 4.522 1.397 4.522 1.397 16.734.777 16.734.777 18 3.306 18 3.306 16.734 2.685 16.734 2.685 10.606 18.425 10.606 18.425 16.734 17.804 16.734 17.804 18 20.333 18 20.333 16.734zM0 0L0 3.255.644 3.255 1.397 3.255 19.713 3.255 20.356 3.255 21 3.255 21 0z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteParadaBusMarquesina);
export default __webpack_public_path__ + "static/media/transporte-parada-bus-marquesina.cd9b129c.svg";
export { ForwardRef as ReactComponent };